import Link from './Link'

/**
 * Chain class
 *      - keeps track of a chain of objects that chase one another
 */
export default class {
    constructor (startMob) {
        this._startMob = startMob
        this._links = []
        this._start = null
        this.game = startMob.game
    }

    add (mob) {
        this._addAtBegin(mob)
        return this
    }

    update (currentTime, isMoving) {
        this._links.forEach((link, position) => link.update(currentTime, isMoving, position))
        return this
    }

    getSize () {
        return this._links.length
    }

    flashColor (color, onTime, travelTime) {
        if (this._start) this._start.emitColor(color, onTime, travelTime)
        return this
    }

    break () {
        this._links.forEach((link) => link.break())
        return this
    }

    _addAtBegin (mob) {
        let link = new Link(mob, this._startMob, 30)
        if (this._start) {
            link.attach(this._start)
            this._start.setDistance(8)
        }
        this._links.unshift(link)
        this._start = link
        return this
    }
}
